export default __webpack_public_path__ + "static/media/private-section.25fff3e1.jpg";